import Paragraph from "@common/components/Paragraph/Paragraph";
import { vars } from "@common/styles";
import { rgba } from "polished";
import { NavLink } from "react-router-dom";
import styled from "styled-components";

export const ActivityHistoryButton = styled(NavLink)`
  display: flex;
  flex-direction: row;
  padding: 1rem;
  border-radius: 1rem;
  border: 0.15rem solid ${vars.colors.sky};
  background-color: ${rgba(vars.colors.sky, 0.15)};
  height: 4rem;
  cursor: pointer;
  align-self: flex-start;
  text-decoration: none !important;

  :hover {
    opacity: 0.7;
  }
`;

export const Image = styled.img`
  margin-right: 1rem;
  width: 2rem;
  height: 2rem;
`;

export const Text = styled(Paragraph)`
  color: ${vars.colors.sky};
`;
